import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8c617aa4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "caption"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Areas of care:", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "pt-1 flex",
  style: {"flex-wrap":"wrap"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_card = _resolveComponent("ion-card")!

  return (_openBlock(), _createBlock(_component_ion_card, {
    button: "",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('goto'))),
    class: "my-pointer ion-activatable pr-2",
    style: _normalizeStyle({
      'border-radius': '4px',
      'border-left':
        '6px solid rgb(' +
        _ctx.getColor(_ctx.contact.category ? _ctx.contact.category.name : '') +
        ')',
    })
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_ripple_effect),
      _createVNode(_component_ion_grid, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, { size: "7" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { class: "ion-text-wrap py-4" }, {
                    default: _withCtx(() => [
                      _createElementVNode("h2", null, _toDisplayString(_ctx.contact.name), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.contact.designation), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, { size: "5" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_thumbnail, { style: {"align-self":"baseline","margin-left":"auto"} }, {
                    default: _withCtx(() => [
                      (_ctx.contact.avatar)
                        ? (_openBlock(), _createBlock(_component_ion_img, {
                            key: 0,
                            class: "circle-me",
                            alt: "avatar",
                            src: 
                _ctx.contact.avatar.formats.thumbnail
                  ? _ctx.contact.avatar.formats.thumbnail.url
                  : _ctx.contact.avatar.url
              ,
                            style: _normalizeStyle({
                border:
                  '4px solid rgb(' +
                  _ctx.getColor(_ctx.contact.category ? _ctx.contact.category.name : '') +
                  ')',
              })
                          }, null, 8, ["src", "style"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, { size: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(_ctx.contact.organization) + " - " + _toDisplayString(_ctx.contact.address), 1),
                      _createElementVNode("p", null, [
                        _createElementVNode("a", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/home/contacts/' + _ctx.contact.id)))
                        }, "More Details")
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, { size: "12" }, {
                default: _withCtx(() => [
                  (_ctx.detail)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
                    : _createCommentVNode("", true),
                  (_ctx.detail)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contact.areas, (area) => {
                          return (_openBlock(), _createBlock(_component_ion_chip, {
                            color: "dark",
                            outline: "",
                            onClick: ($event: any) => (_ctx.$router.push('/home/search?search=' + area.name)),
                            key: area.id + '-area'
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, { color: "dark" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(area.name), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["style"]))
}